define('models/youtubeChannel',["T1", "T1Model"], function (T1, T1Model) {
  "use strict";

  T1.Models.YouTubeChannel = T1Model.extend({
    url: "youtube_channel_targeting/",
    fixture: "-youtube-channel"
  });
  return T1.Models.YouTubeChannel;
});
